import { Link as BaseInternalLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { ExternalLink as BaseExternalLink } from 'components/external-link';

const linkStyles = css`
  display: block;

  color: ${Styles.color.black};
  text-decoration: none;
  font-size: 1rem;

  cursor: pointer;

  &:hover {
    color: ${Styles.color.black};
    text-decoration: underline;
  }

  /* Override global outline color here for contrast ratio */
  :focus {
    outline-color: ${Styles.color.black};
  }
`;

export const InternalLink = styled(BaseInternalLink)`
  ${linkStyles}
`;

export const ExternalLink = styled(BaseExternalLink)`
  ${linkStyles}
`;

const horizontalLinkStyles = css`
  font-size: 0.875rem;
  line-height: 1;
`;

export const HorizontalInternalLink = styled(InternalLink)`
  ${horizontalLinkStyles}
`;

export const HorizontalExternalLink = styled(ExternalLink)`
  ${horizontalLinkStyles}
`;

const highlightedLinkStyles = css`
  color: ${Styles.color.primary};

  &:hover {
    color: ${Styles.color.primary};
  }
`;

export const HighlightedInternalLink = styled(InternalLink)`
  ${highlightedLinkStyles}
`;

export const HighlightedExternalLink = styled(ExternalLink)`
  ${highlightedLinkStyles}
`;

const paddedLinkStyles = css`
  padding-bottom: 0.5rem;
`;

export const PaddedInternalLink = styled(InternalLink)`
  ${paddedLinkStyles}
`;

export const PaddedExternalLink = styled(ExternalLink)`
  ${paddedLinkStyles}
`;
